import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-adhoc-buildinfo.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-adhoc-buildinfo.component.scss?ngResource";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { AppConfig } from "../../../app.config";
let BuildInformationComponent = class BuildInformationComponent {
    activeModalService;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    modalTitle;
    applicationVersion;
    apiVersion;
    closeBtnPlaceholder = "Close";
    ApplicationVersionLabel = "Application Version";
    ApiVersionLabel = "API Version";
    constructor(activeModalService) {
        this.activeModalService = activeModalService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
    }
    onBtnCloseClicked() {
        this.activeModalService.close();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal }
    ];
};
BuildInformationComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-adhoc-buildinfo",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], BuildInformationComponent);
export { BuildInformationComponent };
